define([
], function (
    ) {
    function image_api(url, size) {
        var s = 'small';
        switch(size) {
            case 'small':
                s = '=s140-c';
                break;
            case 'large':
                s = '=s440-c';
                break;
        }
        // URL に最初からサイズ指定がついている場合、それを除去してからオプションを追加
        const index = url.lastIndexOf('=');
        if(index !== -1 && index !== url.length-1) {
            const startIndex = url.length - index;
            url = url.slice(0, -startIndex);
        }
        url += s;
        return url;
    }

    function blob_api(url, size) {
        var s = '';
        switch(size) {
            case 'small':
                s = '?size=140&crop=true';
                break;
            case 'large':
                s = '?size=440&crop=true';
                break;
        }
        return url + s;
    }

    function projectIcon(url, size) {
        switch(size) {
            case 'small':
                return url
            case 'large':
                return `${url}&size=large`;
        }
    }

    function to_image_url(url, size, options) {
        if(!url) {
            return '/image/noimage.png';
        }
        if(url.indexOf('/blobs/') == 0) {
            return blob_api(url, size);
        }
        if(url.indexOf('/_ah/img/') > 0) {
            return image_api(url, size);
        }
        if(url.indexOf('ggpht.com') > 0) {
            return image_api(url, size);
        }
        if(url.indexOf('googleusercontent.com') > 0) {
            return image_api(url, size);
        }
        if(url.indexOf('/content/') == 0) {
            return url;
        }
        if(url.indexOf('/project-icon') > 0) {
            return projectIcon(url, size);
        }
        return url;
    }

    // Handlebars.registerHelper('image', to_image_url);

    return to_image_url;
});



// WEBPACK FOOTER //
// ./common/ui/template/helper/image.js